import React, { useState, useEffect } from 'react';

export default function SurveyTimer({ duration = 30, className = '' }) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const start = Date.now();
    const interval = setInterval(() => {
      const now = Date.now();
      const elapsedSec = Math.min((now - start) / 1000, duration);
      setElapsed(elapsedSec);
      if (elapsedSec >= duration) clearInterval(interval);
    }, 200);
    return () => clearInterval(interval);
  }, [duration]);

  const percent = Math.min((elapsed / duration) * 100, 100);

  return (
    <div
      className={className}
      style={{ width: `${percent}%` }}
      role="progressbar"
      aria-valuenow={Math.round(elapsed)}
      aria-valuemin={0}
      aria-valuemax={duration}
    />
  );
}
